<script>
export default {
    props: {
        count: {
            type: Number,
            required: true
        }
    }
}
</script>

<template>
    <div class="count-notifier flex-all-centered-row">
        {{ count }}
    </div>
</template>

<style lang='scss' scoped>
    .count-notifier {
        text-align: center;
        width: 15px;
        height: 15px;
        border-radius: 200px;
        background-color: var(--icon-red);
        color: white;
        font-weight: bold;
        font-size: .66em;
        padding: .4em;
    }
</style>